import { HostActionType as e } from "../types/HostActionType.mjs";
import { HostActionIntent as t } from "../types/HostActionIntent.mjs";
import { HostActionFacetKind as n } from "../types/HostActionFacet.mjs";
import { HostActionTargetKind as r } from "../types/HostActionTarget.mjs";
//#region src/mappers/toChatActions.ts
var i = (n) => {
	let i = n.filter((e) => e.unread_count > 0);
	if (i.length === 0) return [];
	let a = i.reduce((e, t) => e + t.unread_count, 0), [o] = i;
	return [{
		id: `${e.UnreadMessages}:${o.id}`,
		type: e.UnreadMessages,
		intent: t.Decision,
		imageUrl: o.display?.listing_image ?? void 0,
		avatarName: o.display?.counterpart?.name ?? o.display?.name,
		params: {
			count: a,
			guest: o.display?.counterpart?.name ?? o.display?.name
		},
		object: o.display?.listing_title ?? void 0,
		createdAt: o.last_message_at,
		target: i.length === 1 ? {
			kind: r.Conversation,
			id: o.id
		} : { kind: r.Messages }
	}];
}, a = (i) => {
	let a = i.filter((e) => e.status === "pending");
	if (a.length === 0) return [];
	let o = a.reduce((e, t) => e.created_at <= t.created_at ? e : t);
	return [{
		id: `${e.MessageRequest}:${o.id}`,
		type: e.MessageRequest,
		intent: t.Decision,
		params: { count: a.length },
		facets: [{
			kind: n.Count,
			count: a.length
		}],
		createdAt: o.created_at,
		target: { kind: r.Messages }
	}];
};
//#endregion
export { a as toMessageRequestActions, i as toUnreadMessageActions };
